<template>
  <div>
    <v-container>
      <v-row class="strategio-titles-windows" >
        <v-col cols="12" md="6" lg="8" xl="8" v-show="!isSearching" :style="showMovingMessage ? `margin-top: ${movingMessageHeight}px` : ''">
          <v-row>
            <v-col cols="5" align-self="center">
            <v-icon color="black" style="font-size:52px;padding-bottom: 30px; padding-right: 10px;"
              >low_priority</v-icon>
              <span style="font-size:45px;font-weight:bold;color:black;-webkit-text-stroke: 2px black;">
                Base
              </span>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" md="6" lg="8" xl="8">
          <folder-list-item 
            v-for="f in folders" 
            :key="f.folderID" 
            :folder-data="f"
            :is-searching="isSearching"
            :add-inner-folder="addInnerFolder"
            :add-inner-report="addInnerReport"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FolderListItem from './../folders/folder-list-item'

export default {
  name: 'structure-list',
  data () {
    return {
      showMovingMessage: false
    }
  },
  created () {

  },
  methods: {},
  components: {
    FolderListItem
  },
  props: {
    folders: {
      type: Array,
      default () {
        return []
      }
    },
    containedBy: {
      default () {
        return {}
      }
    },
    isSearching: {
      type: Boolean,
      default () {
        return false
      }
    },
    searchInfo: {
      type: String,
      default () {
        return ''
      }
    },
    addInnerFolder: {
      type: Function,
      default () {
        return () => {}
      }
    },
    addInnerReport: {
      type: Function,
      default () {
        return () => {}
      }
    }
  }
}
</script>

<style scoped>
.strategio-folder-title {
  font-size: 32px;
  font-weight: bold;
  /* vertical-align: middle; */
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/structures/structure-list.vue